module.exports = __webpack_public_path__ + "img/NFFA.56bfc4e5.png";